import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {NgClass} from "@angular/common";
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import Utils from 'src/app/helpers/utils';

@Component({
  selector: 'app-claim-status',
  standalone: true,
  imports: [
      NgClass
  ],
  templateUrl: './claim-status.component.html',
  styleUrl: './claim-status.component.scss'
})
export class ClaimStatusComponent implements OnInit, OnChanges {
  @Input() claimDto!: ClaimDto;
  @Input() minimalUi: boolean = false;
  badgeBackgroundClass: string = '';
  statusText: string = '';

  constructor(private utils: Utils) {
  }
  
  ngOnInit(): void {
    this.updateStatus();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.claimDto) {
      this.updateStatus();
    }
  }
  
  private updateStatus(): void {
    this.badgeBackgroundClass = `bg-${this.utils.renderStatusClass(this.claimDto.status)}`
    this.statusText = this.claimDto!.status;
  }

}
